<template>
  <div class="user">
    <!-- USER HEADER -->
    <div id="user-header">
      <div id="user-header-content">
        <div class="container">
          <div class="row">
            <div class="col-md-3 my-3 avatar-area">
              <img :src="profil.avatar_url" class="img-circle">
              <div class="badge-progress" :style="prgColorAll" title="Progress keseluruhan">
                <span v-if="!is_load">{{overall_progress}}</span>
                <span v-if="is_load"><i class="fa fa-spin fa-spinner"></i></span>
              </div>
            </div>
            <div class="col-md-9 my-3">
              <h1 class="profil-name"><span class="text-gradient">{{profil.name}}</span></h1>
              <p><a :href="'https://github.com/'+username" target="_blank">https://github.com/{{username}} <i class="fa fa-link"></i></a></p>
              <p><i class="fa fa-clock mr-2"></i>Member since {{profil.created_at}}</p>
            </div>
          </div>
        </div>
      </div>
      <div id="user-header-bg" :style="{ backgroundImage: 'url('+profil.avatar_url+')' }"></div>
    </div>
    <!-- USER RESOLUTION -->
    <div id="user-res">
      <div id="user-res-content" class="container">
        <div class="jon-slider-menu row">
          <div class="col-2 col-sm-1 py-2">
            <span v-if="view_mode != 0" @click="prevSlide" :class="{ 'active': view_mode == 0 }" class="btn"><i class="fa fa-chevron-left"></i></span>
          </div>
          <div style="overflow-x: auto" class="col-8 col-sm-10 py-2">
            <div class="jon-slider-menu-overflow">
              <!-- reso.repo jika 0 dianggap belum ngeset, jadi gak bisa liat detail -->
              <span @click="gotoSlide(0)" :class="{ 'active': view_mode == 0 }" class="btn">Overview</span>
              <span @click="gotoSlide(1)" :class="{ 'active': view_mode == 1 }" class="btn">Repository</span>
              <span @click="gotoSlide(2)" :class="{ 'active': view_mode == 2 }" class="btn">Commit</span>
              <span @click="gotoSlide(3)" :class="{ 'active': view_mode == 3 }" class="btn">Star</span>
              <span @click="gotoSlide(4)" :class="{ 'active': view_mode == 4 }" class="btn">Fork</span>
              <span @click="gotoSlide(5)" :class="{ 'active': view_mode == 5 }" class="btn">Follower</span>
              <span @click="gotoSlide(6)" :class="{ 'active': view_mode == 6 }" class="btn">Pull Request</span>
            </div>
          </div>
          <div class="col-2 col-sm-1 py-2">
            <span v-if="view_mode != 6" @click="nextSlide" :class="{ 'active': view_mode == 6 }" class="btn"><i class="fa fa-chevron-right"></i></span>
          </div>
        </div>
        <div v-if="view_mode == 0" id="overview" class="jon-slider">
          <h3 class="text-center mt-5" style="line-height: 1.5em"><b class="text-gradient">Statistik Progress {{profil.name}} Sampai Saat Ini</b></h3>
          <p class="text-center font-courier text-gold">{{date_now}}</p>
          <div v-if="!is_load" class="row justify-content-center">
            <div class="col-lg-3 col-md-6 text-center my-3">
              <CircleProgress v-if="!is_load" :percent="progress.repo" :identifier="1" :key="progress.repo"/>
              <h4>Repository</h4>
              <p class="font-courier mt-0" @click="showModalEdit('Repository','repo')" style="position: relative;">
                <span class="res-progress" :style="prgColorRepo" title="Edit">{{stat.repo+'/'+resolution.repo}}</span>
                <span class="popover" v-if="resolution.repo == 0">Klik progress untuk mencatat resolusi</span>
              </p>
            </div>
            <div class="col-lg-3 col-md-6 text-center my-3">
              <CircleProgress :percent="progress.commit" :identifier="2" :key="progress.commit"/>
              <h4>Commit (2021)</h4>
              <p class="font-courier my-0" @click="showModalEdit('Commit','commit')"><span class="res-progress" :style="prgColorCommit" title="Edit">{{stat.commit+'/'+resolution.commit}}</span></p>
            </div>
            <div class="col-lg-3 col-md-6 text-center my-3">
              <CircleProgress :percent="progress.star" :identifier="3" :key="progress.star"/>
              <h4>Star</h4>
              <p class="font-courier my-0" @click="showModalEdit('Star','star')"><span class="res-progress" :style="prgColorStar" title="Edit">{{stat.star+'/'+resolution.star}}</span></p>
            </div>
            <div class="col-lg-3 col-md-6 text-center my-3">
              <CircleProgress :percent="progress.fork" :identifier="4" :key="progress.fork"/>
              <h4>Fork</h4>
              <p class="font-courier my-0" @click="showModalEdit('Fork','fork')"><span class="res-progress" :style="prgColorFork" title="Edit">{{stat.fork+'/'+resolution.fork}}</span></p>
            </div>
            <div class="col-lg-3 col-md-6 text-center my-3">
              <CircleProgress :percent="progress.follower" :identifier="5" :key="progress.follower"/>
              <h4>Followers</h4>
              <p class="font-courier my-0" @click="showModalEdit('Follower','follower')"><span class="res-progress" :style="prgColorFollower" title="Edit">{{stat.follower+'/'+resolution.follower}}</span></p>
            </div>
            <div class="col-lg-3 col-md-6 text-center my-3">
              <CircleProgress :percent="progress.pull_req" :identifier="6" :key="progress.pull_req"/>
              <h4>Pull Request</h4>
              <p class="font-courier my-0" @click="showModalEdit('Pull Request','pull_req')"><span class="res-progress" :style="prgColorPullReq" title="Edit">{{stat.pull_req+'/'+resolution.pull_req}}</span></p>
            </div>
          </div>
          <!-- ini hanya loader -->
          <UserResolutionLoader v-if="is_load"></UserResolutionLoader>
          <div class="prg-legend-wrapper text-center my-5">
            <span class="prg-legend-area">
              <i class="fa fa-circle mr-1" style="color: rgb(12, 206, 107)"></i> 100
              <i class="fa fa-circle mr-1 ml-4" style="color: rgb(83, 116, 250)"></i> 81 - 99
              <i class="fa fa-circle mr-1 ml-4" style="color: rgb(255, 164, 0)"></i> 41 - 80
              <i class="fa fa-circle mr-1 ml-4" style="color: rgb(255, 105, 105)"></i> 1 - 40
              <i class="fa fa-circle mr-1 ml-4" style="color: rgb(158, 158, 158)"></i> 0
            </span>
          </div>
        </div>

        <SectionRepo
          v-if="view_mode == 1"
          :stat="stat"
          :resolution="resolution"
          :progress="progress"
          :repository="repository"
        ></SectionRepo>

        <SectionCommit
          v-if="view_mode == 2"
          :stat="stat"
          :resolution="resolution"
          :progress="progress"
          :commit="commit"
          :profil="profil"
        ></SectionCommit>

        <SectionStar
          v-if="view_mode == 3"
          :stat="stat"
          :resolution="resolution"
          :progress="progress"
          :star="star"
          :profil="profil"
        ></SectionStar>

        <SectionFork
          v-if="view_mode == 4"
          :stat="stat"
          :resolution="resolution"
          :progress="progress"
          :fork="fork"
          :profil="profil"
          :username="username"
        ></SectionFork>

        <SectionFollower
          v-if="view_mode == 5"
          :stat="stat"
          :resolution="resolution"
          :progress="progress"
          :follower="follower"
        ></SectionFollower>

        <SectionPullRequest
          v-if="view_mode == 6"
          :stat="stat"
          :resolution="resolution"
          :progress="progress"
          :pull_req="pull_req"
        ></SectionPullRequest>
        
      </div>
    </div>
    <div id="footer">
      <p class="text-center my-5">
        Copyright © 2021 <a href="/resolusi-github">Resolusi Programmer 2021</a>. Created by <a href="https://jhonarendra.github.io">Putu Jhonarendra</a><br /><span class="logout" @click="logout">Logout</span> | <span class="logout" @click="$bvModal.show('modalSetPassword')">Ubah Password</span>
      </p>
    </div>
    <button class="btn btn-primary floating-button-refresh" @click="refreshProgressSetLoader">
      <i class="fa fa-sync" :class="{'fa-spin': is_load}"></i>
    </button>
    <b-modal id="modalEdit" :title="modal_edit.title" hide-footer content-class="bg-black">
      <form v-on:submit.prevent="setResolution">
        <p>Jumlah {{modal_edit.title}} yang ingin dicapai tahun 2021</p>
        <input v-if="modal_edit.key == 'repo'" type="number" name="resolution_repo" class="form-control" v-model="resolution.repo" max="10000" :min="stat.repo" required="">
        <input v-if="modal_edit.key == 'commit'" type="number" name="resolution_commit" class="form-control" v-model="resolution.commit" max="10000" :min="stat.commit" required="">
        <input v-if="modal_edit.key == 'star'" type="number" name="resolution_star" class="form-control" v-model="resolution.star" max="10000" :min="stat.star" required="">
        <input v-if="modal_edit.key == 'fork'" type="number" name="resolution_fork" class="form-control" v-model="resolution.fork" max="10000" :min="stat.fork" required="">
        <input v-if="modal_edit.key == 'follower'" type="number" name="resolution_follower" class="form-control" v-model="resolution.follower" max="10000" :min="stat.follower" required="">
        <input v-if="modal_edit.key == 'pull_req'" type="number" name="resolution_pull_req" class="form-control" v-model="resolution.pull_req" max="10000" :min="stat.pull_req" required="">
        <p class="text-center mt-3 mb-0">
          <button type="sumbit" class="btn btn-sm btn-primary">OK</button>
        </p>
      </form>
    </b-modal>
    <b-modal id="modalSetPassword" title="Ubah Password" hide-footer content-class="bg-black">
      <form v-on:submit.prevent="changePassword">
        <div class="form-group">
          <label for="old_password">Password Lama</label>
          <input type="password" class="form-control" id="old_password" v-model="old_password" name="old_password" placeholder="Password Lama" maxlength="16" required="">
        </div>
        <div class="form-group">
          <label for="password">Password Baru</label>
          <input type="password" class="form-control" id="password" v-model="password" name="password" placeholder="Password Baru" maxlength="16" minlength="6" required="">
        </div>
        <div class="form-group">
          <label for="reenter_password">Ketik Ulang Password Baru</label>
          <input type="password" class="form-control" id="reenter_password" name="reenter_password" v-model="reenter_password" placeholder="Ketik Ulang Password Baru" maxlength="16" minlength="6" required="">
        </div>
        <p class="text-center mt-3 mb-0">
          <button type="sumbit" class="btn btn-sm btn-primary">OK</button>
        </p>
      </form>
    </b-modal>

    <div v-if="is_load" class="bar-loader">
      <div class="value-bar-loader"></div>
    </div>
    <p v-if="is_load" class="text-center" style="position: fixed; top:0; width: 100%;z-index: 999">{{progress_load}}</p>
  </div>
</template>

<script>
import axios from 'axios'
import firebase from './../services/firebase'
import SectionRepo from './../components/SectionRepo'
import SectionCommit from './../components/SectionCommit'
import SectionStar from './../components/SectionStar'
import SectionFork from './../components/SectionFork'
import SectionFollower from './../components/SectionFollower'
import SectionPullRequest from './../components/SectionPullRequest'
import CircleProgress from './../components/CircleProgress'
import UserResolutionLoader from './../components/UserResolutionLoader'
// import dummy from './../data/dummy.json'
import './../assets/css/user.css'
export default {
  data () {
    return {
      username: '',
      password: '', // yg diinputin
      reenter_password: '', // input ulang password
      old_password: '', // input password lama
      true_password: '', // yg kesimpen di db
      fbid: '', // firestore collection id
      profil: {},
      stat: {
        repo: '',
        commit: '',
        star: '',
        fork: '',
        follower: '',
        pull_req: ''
      },
      resolution: {
        repo: 0,
        commit: 0,
        star: 0,
        fork: 0,
        follower: 0,
        pull_req: 0
      },
      progress: {
        repo: 0,
        commit: 0,
        star: 0,
        fork: 0,
        follower: 0,
        pull_req: 0
      },
      overall_progress: 0, // stat keseluruhan, di foto profil

      repository: [], // section repo buatin view baru aja nanti
      star: [],
      fork: [],
      follower: [],
      commit: [],
      pull_req: [],

      modal_edit: {
        title: '',
        key: ''
      },
      is_load: true, // lagi loading
      progress_load: 'Mengambil data repository', // text lagi loading (manipulasi)
      date_now: new Date(),
      view_mode: 0 // 0 = overview, 1 = repo, 2 = commit, 3 = star, 4 = fork, 5 = follower, 6 = pull_req
    }
  },
  components: {
    SectionRepo, SectionCommit, SectionStar, SectionFork, SectionFollower, SectionPullRequest, CircleProgress, UserResolutionLoader
  },
  methods: {
    setResolution () {
      if (navigator.onLine) {
        const db = firebase.firestore()
        db.collection('resolution')
          .doc(this.fbid)
          .update({
            resolution: this.resolution
          })
          .then(() => {
            this.$bvModal.hide('modalEdit')
            this.refreshProgress()
            // console.log("Document successfully updated!")
          })
          .catch((error) => {
            alert(error)
            console.error('Error updating document: ', error)
          })
      }
    },
    loadGithubProfile () {
      if (navigator.onLine) {
        axios
          .get('https://api.github.com/users/' + this.username)
          .then(res => {
            this.profil = JSON.parse(JSON.stringify(res.data))
            this.profil.created_at = this.profil.created_at.substr(0, 4)
            this.stat.follower = this.profil.followers

            // load detaul folowe
            axios
              .get('https://api.github.com/users/' + this.username + '/followers')
              .then(res => {
                this.follower = JSON.parse(JSON.stringify(res.data)).slice(0, 6)
              })
          })
      } else {
        // dummy
        this.profil = {
          avatar_url: require('./../assets/img/avatar-1.png'),
          name: 'Jhonarendra',
          created_at: '2015'
        }
        this.username = 'jhonarendra'
        this.stat.follower = 35
      }
    },
    loadGithubRepos () {
      if (navigator.onLine) {
        axios
          .get('https://api.github.com/users/' + this.username + '/repos?per_page=1000')
          .then(res => {
            // this.post = JSON.parse(JSON.stringify(res.data))
            let repos = JSON.parse(JSON.stringify(res.data))
            this.stat.repo = repos.length

            // formatting repository (ambil hanya 6) tampil di section repo
            let repos_selected = []
            for (var i = 0; i < 6; i++) {
              repos_selected.push(repos[i])
            }
            this.repository = repos_selected


            // ambil repository bintang paling banyak
            let repo_star_sort = repos.sort((a,b) => (a.stargazers_count > b.stargazers_count) ? -1 : ((b.stargazers_count > a.stargazers_count) ? 1 : 0))
            let repo_most_star = []
            repo_star_sort.forEach((e) => {
              if(repo_most_star.length <= 3 && e.stargazers_count != 0){
                repo_most_star.push({
                  name: e.name,
                  stargazers_count: e.stargazers_count,
                  stargazers_url: e.stargazers_url
                })
              }
            })
            // console.log(repo_most_star)
            // get star section page
            this.loadGithubStars(repo_most_star)


            // ambil repo forks terbanyak
            let repo_fork_sort = repos.sort((a,b) => (a.forks_count > b.forks_count) ? -1 : ((b.forks_count > a.forks_count) ? 1 : 0))
            let repo_most_fork = []
            repo_fork_sort.forEach((e) => {
              if(repo_most_fork.length <= 3 && e.forks_count != 0){
                repo_most_fork.push({
                  name: e.name,
                  forks_count: e.forks_count,
                  forks_url: e.forks_url
                })
              }
            })
            this.loadGithubForks(repo_most_fork)

            
            // counting stars
            let stars = 0
            repos.forEach((e) => {
              stars += e.stargazers_count
            })
            this.stat.star = stars
            // counting forks
            let forks = 0
            repos.forEach((e) => {
              forks += e.forks_count
            })
            this.stat.fork = forks
          })
      } else {
        // dummy
        this.stat.repo = 20
        this.stat.star = 30
        this.stat.fork = 20
      }
    },
    loadGithubEvents () {
      if (navigator.onLine) {
        axios
          .get('https://api.github.com/users/' + this.username + '/events?per_page=1000')
          .then(res => {
            let events = JSON.parse(JSON.stringify(res.data))
            let commits = 0
            let pullReqs = 0
            let commit_selected = []
            let pull_req_selected = []
            events.forEach((e) => {
              if (e.type === 'PushEvent' && e.created_at.substr(0, 4) === '2021') {
                commits += 1
                if(commit_selected.length <= 6){
                  commit_selected.push(e)
                }
              }
              if (e.type === 'PullRequestEvent' && e.created_at.substr(0, 4) === '2021') {
                pullReqs += 1
                if(pull_req_selected.length <= 6){
                  pull_req_selected.push(e)
                }
              }
            })
            this.commit = commit_selected
            this.pull_req = pull_req_selected
            this.stat.commit = commits
            this.stat.pull_req = pullReqs
          })
      } else {
        // dummy
        this.stat.commit = 20
        this.stat.pull_req = 4
      }
    },
    loadGithubStars (repo) {
      let stars = []
      repo.forEach((e) => {
        axios
          .get(e.stargazers_url)
          .then(res => {
            let data = JSON.parse(JSON.stringify(res.data))
            stars.push({
              name: e.name,
              stargazers_count: e.stargazers_count,
              data: data
            })
          })
      })
      setTimeout(() => {
        stars = stars.sort((a,b) => (a.stargazers_count > b.stargazers_count) ? -1 : ((b.stargazers_count > a.stargazers_count) ? 1 : 0))
        this.star = stars
      }, 1000)
    },
    loadGithubForks (repo) {
      let forks = []
      repo.forEach((e) => {
        axios
          .get(e.forks_url)
          .then(res => {
            let data = JSON.parse(JSON.stringify(res.data))
            forks.push({
              name: e.name,
              forks_url: e.forks_url,
              data: data
            })
          })
      })
      setTimeout(() => {
        forks = forks.sort((a,b) => (a.forks_url > b.forks_url) ? -1 : ((b.forks_url > a.forks_url) ? 1 : 0))
        this.fork = forks
      }, 1000)
    },
    loadResolution () {
      if (navigator.onLine) {
        const db = firebase.firestore()
        db.collection('resolution')
          .get()
          .then((q) => {
            q.forEach((doc) => {
              if (doc.data().username === this.username) {
                this.resolution = doc.data().resolution
                this.fbid = doc.id
                this.true_password = doc.data().password
              }
            })
          })
          .catch((error) => {
            alert(error)
            console.error('Error getting documents: ', error)
          })
      } else {
        // dummy
        this.resolution = {
          repo: 30,
          commit: 3000,
          star: 30,
          fork: 50,
          follower: 40,
          pull_req: 20
        }
        this.true_password = '88888888'
      }
    },
    refreshProgress () {
      this.progress = {
        repo: parseInt(this.stat.repo / this.resolution.repo * 100),
        commit: parseInt(this.stat.commit / this.resolution.commit * 100),
        star: parseInt(this.stat.star / this.resolution.star * 100),
        fork: parseInt(this.stat.fork / this.resolution.fork * 100),
        follower: parseInt(this.stat.follower / this.resolution.follower * 100),
        pull_req: parseInt(this.stat.pull_req / this.resolution.pull_req * 100)
      }
      this.overall_progress = parseInt((this.progress.repo + this.progress.commit + this.progress.star + this.progress.fork + this.progress.follower + this.progress.pull_req) / 6)
    },
    showModalEdit (title, key) {
      this.modal_edit.title = title
      this.modal_edit.key = key
      this.$bvModal.show('modalEdit')
    },
    logout () {
      localStorage.removeItem('gr_username')
      setTimeout(() => {
        this.$router.push({ path: '/resolusi-github' })
      }, 500)
      document.getElementsByClassName('user')[0].classList.remove('show')
    },
    changePassword () {
      if (this.true_password !== this.old_password) {
        alert('Password lama tidak cocok')
        return false
      }
      if (this.password !== this.reenter_password) {
        alert('Password yang diketik ulang tidak sama')
        return false
      }
      if (this.true_password === this.old_password && this.password === this.reenter_password) {
        if (navigator.onLine) {
          const db = firebase.firestore()
          db.collection('resolution')
            .doc(this.fbid)
            .update({
              password: this.password
            })
            .then(() => {
              alert('Berhasil ubah password')
              this.$bvModal.hide('modalSetPassword')
              this.password = ''
              this.old_password = ''
              this.reenter_password = ''
            })
            .catch((error) => {
              alert(error)
              console.error('Error updating document: ', error)
            })
        }
      }
    },
    refreshProgressSetLoader () {
      this.is_load = true
      setTimeout(() => {
        this.progress_load = 'Mengambil data commit'
      }, 2500)
      setTimeout(() => {
        this.progress_load = 'Mengambil data star'
      }, 4000)
      setTimeout(() => {
        this.progress_load = 'Mengambil data fork'
      }, 4900)
      setTimeout(() => {
        this.progress_load = 'Mengambil data follower'
      }, 5200)
      setTimeout(() => {
        this.progress_load = 'Mengambil data pull request'
      }, 6000)
      setTimeout(() => {
        this.progress_load = 'Selesai'
      }, 6100)
      setTimeout(() => {
        this.is_load = false
        this.refreshProgress()
        this.progress_load = 'Mengambil data repository'
      }, 6500)
    },
    prgColor (val) {
      if (val === 0) {
        return 'color: #9E9E9E; border-color: #9E9E9E'
      } else if (val <= 40) {
        return 'color: #FF6969; border-color: #FF6969'
      } else if (val <= 80) {
        return 'color: #FFA400; border-color: #FFA400'
      } else if (val < 100) {
        return 'color: #5374FA; border-color: #5374FA'
      } else if (val === 100) {
        return 'color: #0CCE6B; border-color: #0CCE6B'
      }
    },
    getSlideId (val) {
      let slide_id = ''
      switch (val) {
        case 0:
          slide_id = 'overview'
          break
        case 1:
          slide_id = 'repository'
          break
        case 2:
          slide_id = 'commit'
          break
        case 3:
          slide_id = 'star'
          break
        case 4:
          slide_id = 'fork'
          break
        case 5:
          slide_id = 'follower'
          break
        case 6:
          slide_id = 'pull_req'
          break
        default:
          slide_id = 'overview'
      }
      return slide_id
    },
    nextSlide () {
      if(this.resolution.repo != 0){
        let slide_id = this.getSlideId(this.view_mode)
        document.getElementById(slide_id).classList.remove('show')

        let new_slide_id = ''
        setTimeout(() => {
          this.view_mode = this.view_mode + 1
          new_slide_id = this.getSlideId(this.view_mode)
        }, 300)
        setTimeout(() => {
          document.getElementById(new_slide_id).classList.add('show')
        }, 400)
      }
    },
    prevSlide () { // sama kayak nextSlide, cuma beda di this.view_mode = this.view_mode - 1
      if(this.resolution.repo != 0){
        let slide_id = this.getSlideId(this.view_mode)
        document.getElementById(slide_id).classList.remove('show')

        let new_slide_id = ''
        setTimeout(() => {
          this.view_mode = this.view_mode - 1
          new_slide_id = this.getSlideId(this.view_mode)
        }, 300)
        setTimeout(() => {
          document.getElementById(new_slide_id).classList.add('show')
        }, 400)
      }
    },
    gotoSlide (val) {
      if(this.resolution.repo != 0){
        let slide_id = this.getSlideId(this.view_mode)
        document.getElementById(slide_id).classList.remove('show')

        let new_slide_id = ''
        setTimeout(() => {
          this.view_mode = val
          new_slide_id = this.getSlideId(this.view_mode)
        }, 300)
        setTimeout(() => {
          document.getElementById(new_slide_id).classList.add('show')
        }, 400)
      }
    }
  },
  mounted () {
    setTimeout(() => {
      document.getElementsByClassName('user')[0].classList.add('show')
      document.getElementById('overview').classList.add('show')
    }, 500)
  },
  created () {
    if (localStorage.gr_username) {
      this.username = localStorage.getItem('gr_username')
      if (this.$route.params.username === this.username) {
        this.loadGithubProfile()
        this.loadGithubRepos()
        this.loadGithubEvents()
        this.loadResolution()

        this.refreshProgressSetLoader()
      } else {
        this.$router.push({ path:'/resolusi-github/' })
      }
    } else {
      this.$router.push({ path:'/resolusi-github' })
    }
  },
  computed: {
    prgColorRepo () {
      return this.prgColor(this.progress.repo)
    },
    prgColorCommit () {
      return this.prgColor(this.progress.commit)
    },
    prgColorStar () {
      return this.prgColor(this.progress.star)
    },
    prgColorFork () {
      return this.prgColor(this.progress.fork)
    },
    prgColorFollower () {
      return this.prgColor(this.progress.follower)
    },
    prgColorPullReq () {
      return this.prgColor(this.progress.pull_req)
    },
    prgColorAll () {
      if (this.overall_progress === 0) {
        return 'background: rgb(42,42,42); color: #9E9E9E; border-color: #9E9E9E'
      } else if (this.overall_progress <= 40) {
        return 'background: rgb(68,28,28); color: #FF6969; border-color: #FF6969'
      } else if (this.overall_progress <= 80) {
        return 'background: rgb(68,44,0); color: #FFA400; border-color: #FFA400'
      } else if (this.overall_progress < 100) {
        return 'background: rgb(22,31,67); color: #5374FA; border-color: #5374FA'
      } else if (this.overall_progress === 100) {
        return 'background: rgb(3,55,29); color: #0CCE6B; border-color: #0CCE6B'
      } else {
        return 'background: rgb(42,42,42); color: #9E9E9E; border-color: #9E9E9E'
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped="">

</style>
